module.exports = __webpack_public_path__ + "static/media/Estrellas.e562684e.svg";